import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SecurableObjectAcessControlEntry } from '../../../../Models/SecurableObjectAcessControlEntry';
import { AccessControlComponent } from '../access-control.component';
import {WfTableComponent} from '../../../../common/table-sort/wf-table.component';

@Component({
  selector: 'app-state-table',
  templateUrl: './state-permission-table.component.html',
  styleUrls: ['../access-control.component.css']
})

export class StatePermissionTableComponent {

  @Input()
  stateAccessControlEntries: SecurableObjectAcessControlEntry[];

  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(private accessControl: AccessControlComponent) { }

  insertSpacesPermissionName(permissionName: string) {
    const permissionNames = permissionName.match(/[[A-Z][a-zà-ú]+/g);
    return permissionNames.join(' ');
  }

}
